<script setup lang="ts">
import { ref } from 'vue';
import StfDialog from '@/ui/dialog/StfDialog.vue';

interface Props {
    title: string;
    help?: boolean;
    helpTitle?: string;
}

withDefaults(defineProps<Props>(), {
    help: false,
    helpTitle: 'Help',
});

const showHelpDialog = ref(false);
</script>

<template>
    <StfRow vcenter>
        <StfCol><stf-heading>{{title}}</stf-heading></StfCol>
        <StfCol v-if="help" class="has-text-right" narrow>
            <StfBody class="stf-clickable stf-help-link" @click="() => showHelpDialog = true">
                <u>Need Help?</u>
            </StfBody>
        </StfCol>
        <StfCol v-if="$slots.right" class="has-text-right">
            <slot name="right" />
        </StfCol>
    </StfRow>
    
    <StfDialog v-model="showHelpDialog">
        <template #title>
            <strong>{{ helpTitle }}</strong>
        </template>
        <slot name="help"></slot>
    </StfDialog>
</template>

